export default __webpack_public_path__ + "static/media/faci04.4da686dc.jpg";